import { render, staticRenderFns } from "./AddSingleDns.vue?vue&type=template&id=c0332e68&scoped=true"
import script from "./AddSingleDns.vue?vue&type=script&lang=js"
export * from "./AddSingleDns.vue?vue&type=script&lang=js"
import style0 from "./AddSingleDns.vue?vue&type=style&index=0&id=c0332e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0332e68",
  null
  
)

export default component.exports